export default "__VITE_ASSET__42c810d6__"